import { usePathname, useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { useSafeBackNavigation } from './useSafeBackNavigation';

export function useTelegramBackButton({ onBack }: { onBack?: () => void }) {
  const router = useRouter();
  const pathname = usePathname();
  const { safeBack } = useSafeBackNavigation();

  useEffect(() => {
    if (typeof window === 'undefined' || !window?.Telegram?.WebApp?.BackButton)
      return;

    const BackButton = window?.Telegram.WebApp.BackButton;

    if (
      pathname !== '/' &&
      pathname !== '/uz' &&
      pathname !== '/en'
    ) {
      BackButton.show();
      BackButton.onClick(() => {
        if (onBack) {
          onBack();
        } else {
          safeBack('/');
        }
      });
    } else {
      BackButton.hide();
      BackButton.onClick(null);
    }

    return () => {
      BackButton.onClick(null);
    };
  }, [router, pathname, safeBack, onBack]);

  return {
    isVisible:
      typeof window === 'undefined'
        ? false
        : window?.Telegram?.WebApp?.BackButton?.isVisible,
  };
}
